<template>
  <v-skeleton-loader v-if="loading" type="list-item@5"></v-skeleton-loader>

  <div v-else>
    <template v-for="(item, idx) in items">
      <v-hover v-slot="{hover: listItemHover}" :key="`recommendations-${idx}`">
        <v-list-item @click="onClickInclude(item)">
          <v-list-item-avatar v-if="item.avatar" size="30">
            <v-img :src="item.avatar"></v-img>
          </v-list-item-avatar>

          <v-list-item-content
            :style="{
              color: listItemHover ? 'var(--primary)' : '',
            }"
            @mouseover="onItemMouseOver"
            @mouseout="onItemMouseOut"
          >
            <v-list-item-title>{{ item.text }}</v-list-item-title>

            <template v-if="item.details">
              <div
                v-for="(detail, idx) in item.details"
                :key="`${idx}-${detail.text}`"
                class="d-flex text-truncate"
              >
                <z-icon size="15" class="mr-1">{{ detail.icon }}</z-icon>
                <v-list-item-subtitle>
                  {{ detail.text }}
                </v-list-item-subtitle>
              </div>
            </template>
          </v-list-item-content>

          <v-list-item-action v-show="listItemHover">
            <div class="d-flex align-center" style="gap: 2px">
              <v-hover v-slot="{hover: includeHover}">
                <span
                  tabindex="0"
                  :style="{
                    color: includeHover ? 'var(--primary)' : '',
                    cursor: 'pointer',
                    'user-select': 'none',
                  }"
                  @mouseover="onIncludeMouseOver"
                  @mouseout="onIncludeMouseOut"
                  @keydown.enter="onClickInclude(item)"
                  @click.self.stop="onClickInclude(item)"
                >
                  {{ $t('include') }}
                </span>
              </v-hover>

              <span>|</span>

              <v-hover v-slot="{hover: excludeHover}">
                <span
                  tabindex="0"
                  :style="{
                    color: excludeHover ? 'var(--red)' : '',
                    cursor: 'pointer',
                    'user-select': 'none',
                  }"
                  @mouseover="onExcludeMouseOver"
                  @mouseout="onExcludeMouseOut"
                  @keydown.enter="onClickExclude(item)"
                  @click.self.stop="onClickExclude(item)"
                >
                  {{ $t('exclude') }}
                </span>
              </v-hover>
            </div>
          </v-list-item-action>
        </v-list-item>
      </v-hover>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ZExclusionList',
  props: {
    items: {
      type: Array,
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onClickInclude(item) {
      this.$emit('include', item)
    },

    onClickExclude(item) {
      this.$emit('exclude', item)
    },

    /** EVENTOS PARA CUSTOMIZAÇÃO DA LISTA */
    onItemMouseOver(e) {
      const listItem = e.target.closest('.v-list-item')
      const contents = listItem.querySelector('.v-list-item__content').children

      if (listItem) {
        this.$nextTick(() => {
          for (const div of contents) {
            div.classList.add('include-item')
          }
          const includeSpan = listItem.querySelector('span:first-child')
          includeSpan.classList.add('include-item')
        })
      }
    },

    onItemMouseOut(e) {
      const listItem = e.target.closest('.v-list-item')
      const contents = listItem.querySelector('.v-list-item__content').children

      if (listItem) {
        this.$nextTick(() => {
          for (const div of contents) {
            div.classList.remove('include-item')
          }

          const includeSpan = listItem.querySelector('span:first-child')
          includeSpan.classList.remove('include-item')
        })
      }
    },

    onIncludeMouseOver(e) {
      const contents =
        e.target.parentElement.parentElement.previousElementSibling.children

      if (contents) {
        this.$nextTick(() => {
          for (const div of contents) {
            div.classList.add('include-item')
          }
        })
      }
    },

    onIncludeMouseOut(e) {
      const contents =
        e.target.parentElement.parentElement.previousElementSibling.children

      if (contents) {
        this.$nextTick(() => {
          for (const div of contents) {
            div.classList.remove('include-item')
          }
        })
      }
    },

    onExcludeMouseOver(e) {
      const contents =
        e.target.parentElement.parentElement.previousElementSibling.children

      if (contents) {
        this.$nextTick(() => {
          for (const div of contents) {
            div.classList.add('exclude-item')
          }
        })
      }
    },

    onExcludeMouseOut(e) {
      const contents =
        e.target.parentElement.parentElement.previousElementSibling.children

      if (contents) {
        this.$nextTick(() => {
          for (const div of contents) {
            div.classList.remove('exclude-item')
          }
        })
      }
    },
  },

  i18n: {
    messages: {
      en: {
        include: 'Include',
        exclude: 'Exclude',
      },

      pt: {
        include: 'Incluir',
        exclude: 'Excluir',
      },

      es: {
        include: 'Incluir',
        exclude: 'Excluir',
      },
      fr: {
        include: 'Inclure',
        exclude: 'Exclure',
      },
      tr: {
        include: 'Dahil et',
        exclude: 'Hariç tut',
      },
    },
  },
}
</script>

<style scoped lang="scss">
:deep(.v-skeleton-loader__list-item) {
  height: 20px !important;
}

:deep(.v-list-item__action) {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.include-item,
.include-item * {
  color: var(--primary) !important;
}

.exclude-item,
.exclude-item * {
  color: var(--red) !important;
}
</style>
